import React from 'react';
import { Flex } from 'antd';
import TextCopy from '../text-copy';
import TextWithIcon from '../text-with-icon';
import { formatPhoneNo } from '../../../utils/utils';
import { useSelector } from 'react-redux';

const UserInfo = ({ name, phoneNumber, phoneCopyable = true, email }) => {
  const { tenant } = useSelector((state) => state.tenantData);
  return (
    <Flex vertical gap={8}>
      <span className="fw-700">{name}</span>

      {phoneNumber && (
        <TextWithIcon
          icon="MdCall"
          text={
            <TextCopy
              value={formatPhoneNo(phoneNumber, tenant?.name)}
              copyable={phoneCopyable}
              removeSpaces={true}
              style={{ fontSize: 'var(--ant-font-size-sm)', lineHeight: 1 }}
            />
          }
        />
      )}
      {email && <TextWithIcon icon="MdEmail" text={email} className="lineHeight1" />}
    </Flex>
  );
};

export default UserInfo;
